import { render, staticRenderFns } from "./testreportelement.vue?vue&type=template&id=3b3f7ec0&"
import script from "../../ts/articleattributes/testreportelement.ts?vue&type=script&lang=js&"
export * from "../../ts/articleattributes/testreportelement.ts?vue&type=script&lang=js&"
import style0 from "../../assets/css/articleattributes/testreportelement.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports